import React from 'react';
import { InputNumber } from 'antd';
import { FJ730 } from '../../../services/j218Api';
import { dateToInput, inputToDate } from '../helpers';
import LookupField from '../../../components/LookupField';

interface Tab1Props {
  formData: Partial<FJ730>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof FJ730) => unknown;
  setField: (key: keyof FJ730, value: unknown) => void;
  resolveSingleName: (key: string, type: string, code: string) => void;
}

const Tab1BasicInfo: React.FC<Tab1Props> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName,
}) => (
  <div className="form-grid">
    <label>開發單號</label>
    <LookupField lookupType="salesContract" value={String(getField('fj730_11') || '')}
      onChange={(code) => { setField('fj730_11', code); resolveSingleName('devOrder', 'devorder', code); }}
      disabled={!isEditing} title="選擇開發單號" />

    <label>產品用途</label>
    <LookupField lookupType="product" value={String(getField('fj730_13') || '')}
      onChange={(code) => { setField('fj730_13', code); resolveSingleName('usage', 'usage', code); }}
      disabled={!isEditing} title="選擇產品用途" />

    <label>廠商收件單號</label>
    <LookupField lookupType="purchaseReceipt" value={String(getField('fj730_14') || '')}
      onChange={(code) => setField('fj730_14', code)}
      disabled={!isEditing} title="選擇廠商收件單號" />

    <label>收件單項次</label>
    <LookupField lookupType="purchaseReceipt" contractFieldId="fj730_15" value={String(getField('fj730_15') || '')}
      onChange={(code) => setField('fj730_15', code)}
      disabled={!isEditing} title="選擇收件單項次" />

    <label>產品代號(前)</label>
    <input data-contract-field="fj730_161" value={String(getField('fj730_161') || '')} disabled={!isEditing}
      onChange={e => setField('fj730_161', e.target.value)} />

    <label>產品代號(後)</label>
    <input data-contract-field="fj730_162" value={String(getField('fj730_162') || '')} disabled={!isEditing}
      onChange={e => setField('fj730_162', e.target.value)} />

    <label>布樣數量</label>
    <InputNumber data-contract-field="fj730_18" value={Number(getField('fj730_18') || 0)} disabled={!isEditing}
      onChange={v => setField('fj730_18', v || 0)} />

    <label>繳交研發處布樣數量</label>
    <InputNumber data-contract-field="fj730_181" value={Number(getField('fj730_181') || 0)} disabled={!isEditing}
      onChange={v => setField('fj730_181', v || 0)} />

    <label>布樣單位</label>
    <input data-contract-field="fj730_182" value={String(getField('fj730_182') || '')} disabled={!isEditing} maxLength={6}
      onChange={e => setField('fj730_182', e.target.value)} />

    <label>產品代號</label>
    <input value={String(getField('fj730_19') || '')} disabled={!isEditing} maxLength={3}
      onChange={e => setField('fj730_19', e.target.value)} />

    <label>/</label>
    <input data-contract-field="fj730_191" value={String(getField('fj730_191') || '')} disabled={!isEditing} maxLength={3}
      onChange={e => setField('fj730_191', e.target.value)} />

    <label>產品規格備忘1</label>
    <input data-contract-field="fj730_171" value={String(getField('fj730_171') || '')} disabled={!isEditing} maxLength={3}
      onChange={e => setField('fj730_171', e.target.value)} />

    <label>產品規格備忘2</label>
    <input data-contract-field="fj730_172" value={String(getField('fj730_172') || '')} disabled={!isEditing} maxLength={50}
      onChange={e => setField('fj730_172', e.target.value)} />

    <label>產品規格</label>
    <textarea className="spec-memo" value={String(getField('fj730_17') || '')} disabled={!isEditing}
      onChange={e => setField('fj730_17', e.target.value)} rows={3} />

    <label>公告開始日</label>
    <input data-contract-field="fj730_77" type="date" value={dateToInput(getField('fj730_77') as string)} disabled={!isEditing}
      onChange={e => setField('fj730_77', inputToDate(e.target.value))} />

    <label>公告終止日</label>
    <input data-contract-field="fj730_78" type="date" value={dateToInput(getField('fj730_78') as string)} disabled={!isEditing}
      onChange={e => setField('fj730_78', inputToDate(e.target.value))} />

    <label>入單人員</label>
    <div className="lookup-field">
      <input value={String(getField('fj730_62') || '')} disabled className="readonly-field" />
      <span className="lookup-name">{names.employee || ''}</span>
    </div>

    <label>入單部門</label>
    <div className="lookup-field">
      <input data-contract-field="fj730_63" value={String(getField('fj730_63') || '')} disabled className="readonly-field" />
      <span className="lookup-name">{names.department || ''}</span>
    </div>

    <label>業務分析單號</label>
    <input value={String(getField('fj730_76') || '')} disabled className="readonly-field" />

    <label>核准狀態</label>
    <input value={String(getField('fj730_80') || '')} disabled className="readonly-field" />
  </div>
));

Tab1BasicInfo.displayName = 'Tab1BasicInfo';
export default Tab1BasicInfo;
